<template>
  <!-- Login Section 01 -->
  <div class="login-section">
    <section class>
      <div class="container_1">
        <div class="row justify-content-center">
          <div class="col-lg-12 order-lg-2">
            <div class="hero-image">
              <img src="/assets/exported/login.jpg" alt />
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="error" class="error_body_reset">
      <div class="container login_hero">
        <h2 style="text-align: center;">{{error}}</h2>
        <div class="container" style="width:80%">
          <p
            class="error-reset"
          >আপনার ইমেইল নতুন একটি লিংক গিয়েছে। অনুগ্রহ করে সেই লিংক দিয়ে আবার চেষ্টা করুন।</p>
        </div>
      </div>
    </div>
    <div v-if="!error" class="container login_hero">
      <h2>পাসওয়ার্ড পরিবর্তন করুন</h2>
      <form method="post" @submit.prevent>
        <div class="container">
          <label for="email">
            <b>{{ $root.login_email.login_e_text }}</b>
          </label>
          <input type="text" placeholder name="email" v-model="user_email" disabled />
          <label for="pw1">
            <b>{{ $root.login_password.login_p_text }}</b>
          </label>
          <input type="password" placeholder name="pw1" v-model="user_password" />
          <!-- Error masaage -->
          <div
            class="error_body"
            v-if="typeof errormessage.errors != 'undefined' && passwordError == true"
          >
            <ul v-if="typeof errormessage.errors.password != 'undefined'">
              <li
                v-for="password_id in errormessage.errors.password"
                :key="password_id.id"
                class="error_data"
              >{{password_id}}</li>
            </ul>
          </div>
          <!-- Error masaage end-->
          <label for="pw2">
            <b>{{$root.rg_re_pass.rg_re_pass_text}}</b>
          </label>
          <input type="password" placeholder name="pw2" v-model="user_password_confirm" />
          <!-- Error masaage -->
          <div
            class="error_body"
            v-if="typeof errormessage.errors != 'undefined' && passwordError == true"
          >
            <ul v-if="typeof errormessage.errors.password != 'undefined'">
              <li
                v-for="password_id in errormessage.errors.password"
                :key="password_id.id"
                class="error_data"
              >{{password_id}}</li>
            </ul>
          </div>
          <!-- Error masaage end-->
          <div class="log_button">
            <button type="submit" @click="reset_confirm()">
              পাসওয়ার্ড পরিবর্তন
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
export default {
  name: "",
  data() {
    return {
      token: "",
      user_email: "",
      user_password: "",
      user_password_confirm: "",
      error: "",
      errors: [],
      email: [],
      message: [],
      errormessage: [],
      passwordError: false,
      password: [],
    };
  },
  components: {},

  methods: {
    validate_token() {
      var validation_url =
        this.$root.API_BASE_URL + "password-find/" + this.token;
      axios

        .get(validation_url)
        .then((response) => {
          if (response.data.email != null) {
            this.user_email = response.data.email;
            console.log(response.data.token);
          }
        })
        .catch((error) => {
          this.error = "পাসওয়ার্ড পরিবর্তনের লিংকটি পূর্বের!";
          //swal('পাসওয়ার্ড পরিবর্তনের লিংকটি পূর্বের!');
          console.log("ERRRR:: ", error);
        });
    },
    reset_confirm() {
      // Send Profile To Server
      axios
        .post(this.$root.API_BASE_URL + "forgot-password-change", {
          email: this.user_email,
          password: this.user_password,
          password_confirmation: this.user_password_confirm,
          token: this.token,
        })
        .then(() => {
          swal({
            text: "পাসওয়ার্ড পরিবর্তন হয়েছে।",
            buttons: {
              confirm: { text: "ঠিক আছে" },
            },
          });
          window.localStorage.clear();
          this.$router.push({ path: "/login" });
        })
        .catch((error) => {
          this.errormessage = error.response.data;
          if (typeof this.errormessage.errors.password != "undefined") {
            this.passwordError = true;
          }
          console.log("ERRRR:: ", error);
        });
    },
  },
  mounted() {
    this.token = this.$route.query.reset_token;
    this.validate_token();
  },
};
</script>
<style scoped>
.error_body_reset {
  width: 100%;
}
.error-reset {
  padding: 15px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}
</style>